import freeIcon from '../../../../../assets/hero_free.png';
import graphics3DIcon from '../../../../../assets/hero_graphics3D.png';
import simpleIcon from '../../../../../assets/hero_simple.png';
import skinsIcon from '../../../../../assets/hero_skins.png';
import polyglot from '../../../../../localization';

import { LightningHeroAdvantage } from './LightningHeroAdvantage';

import './styles.scss';

/**
 * LightningHeroAdvantages renders the four localized advantage cards
 * in the lightning hero section.
 *
 * @param {string} lang — Language key used to localize advantage texts and alt labels.
 */
export const LightningHeroAdvantages = ({ lang }) => (
    <div className='lightning-hero-advantages'>
        <LightningHeroAdvantage
            lang={lang}
            src={freeIcon}
            alt={polyglot.t(`${lang}.hero.alt.lock`)}
            description={polyglot.t(`${lang}.advantages.free`)}
        />
        <LightningHeroAdvantage
            lang={lang}
            src={skinsIcon}
            alt={polyglot.t(`${lang}.hero.alt.skins`)}
            description={polyglot.t(`${lang}.advantages.skins`)}
        />
        <LightningHeroAdvantage
            lang={lang}
            src={graphics3DIcon}
            alt={polyglot.t(`${lang}.hero.alt.3d`)}
            description={polyglot.t(`${lang}.advantages.graphics3D`)}
        />
        <LightningHeroAdvantage
            lang={lang}
            src={simpleIcon}
            alt={polyglot.t(`${lang}.hero.alt.puzzle`)}
            description={polyglot.t(`${lang}.advantages.simple`)}
        />
    </div>
);
